import React from "react";
import { Form } from "react-bootstrap";
import { Loader } from "rsuite";
import { ImageUrl } from "../../utils/config/config";
import { ImageFileInput } from "./ImageFileInput";

/**
 * The Logo field of the Sport and Team forms (#306), Add and Update alike: label, picker, hint and
 * the image the save will send. `image` is the form's useImageUpload, which decides what a failed
 * upload does; the preview is its `name`, so it shows the stored image, not the file picked.
 *
 * A logo is optional - Add and Update both save without one - so the hint (ImageFileInput's,
 * IMAGE_HINT, #308) carries no required mark (the Add forms used to show a red "*").
 *
 * @param {object} props
 * @param {string} props.name The file input's name.
 * @param {{name: string | null, uploading: boolean, upload: Function}} props.image The form's useImageUpload.
 * @param {string} [props.placeholder] Shown while there is no image; Update passes the default icon,
 *   Add passes nothing and shows no preview until something is uploaded.
 * @param {boolean} [props.busy] Shows the loader for something besides the upload (a save on its way).
 */
export const LogoField = ({ name, image, placeholder, busy = false }) => {
  const preview = image.name ? ImageUrl + image.name : placeholder;
  return (
    <>
      <Form.Label>Logo</Form.Label>
      <ImageFileInput name={name} onPick={image.upload} />
      {(busy || image.uploading) && <Loader />}
      {preview && <img src={preview} alt="Logo" width={100} className="mt-2" />}
    </>
  );
};
